// extracted by mini-css-extract-plugin
export default {"moduleOpened":"hqo2x","moduleIcon":"BW0gi","moduleHeader":"mq0mi","modulePreview":"mSPNQ","moduleTitle":"mS6uF","moduleInner":"MP1Zm","addBtn":"mKWh8"};